import React from 'react';
import './App.css';
import { Route, Routes } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import VideoViewPage from "./components/VideoViewPage";


export const config = {
  endpoint: `https://fe9c0f52-c39d-4deb-99d1-50652e040580.mock.pstmn.io/v1`,
};

function App() {
  return (
    <div className="App">
      <React.StrictMode>
        <Routes>
          <Route path="/" element = {<LandingPage/>} />
          <Route path="/video/:id" element = {<VideoViewPage/>} />
        </Routes>
      </React.StrictMode>
    </div>
  );
}

export default App;
